// src/pages/QrKodPage.js
import React, { useEffect, useRef, useState } from "react";
import { API_BASE } from "../config";
import { QRCodeSVG } from "qrcode.react";

/* =========================
   3 DİL DESTEK
========================= */
const t = {
  tr: {
    title: "Profesyonel QR Kod Oluştur",
    subtitle:
      "QR Menü, muhtarlık, dernek, uygulama indirme ve özel bağlantılar için profesyonel baskı şablonları oluşturun.",
    loading: "Yükleniyor...",
    qrPreview: "QR Önizleme",
    qrLink: "QR Linki",
    customUrlLabel: "QR kodun gideceği link",
    customUrlPlaceholder: "Kurumunuza ait bağlantıyı buraya yazın",
    reset: "Kurum linkine dön",
    copy: "Linki Kopyala",
    copied: "Kopyalandı!",
    share: "Paylaş",
    downloadQr: "Sade QR İndir",
    printTitle: "Profesyonel Baskı Şablonu",
    printSubtitle:
      "Muhtarlık, dernek, restoran, uygulama ve özel kullanım için 3000x3000 px PNG veya SVG vektör çıktı alın.",
    downloadPng: "Baskı PNG İndir",
    downloadSvg: "SVG Vektör İndir",
    templateType: "Şablon Tipi",
    settings: "Şablon Ayarları",
    textSettings: "Yazı Alanları",
    colorSettings: "Renk Ayarları",
    logoSettings: "Orta Logo",
    templateMenu: "QR Menü / Masa",
    templateMuhtar: "Muhtarlık",
    templateDernek: "Dernek",
    templateApp: "Google Play / App Store",
    templateSimple: "Sade Özel QR",
    businessName: "Kurum / Marka Adı",
    titleLine1: "Üst başlık 1",
    titleLine2: "Üst başlık 2",
    sideText: "Sağ-sol dikey yazı",
    footerText: "Alt açıklama",
    bgColor: "Ana arka plan",
    accentColor: "Çerçeve / vurgu",
    qrBgColor: "QR alan rengi",
    textColor: "Yazı rengi",
    showTitle: "Üst başlığı göster",
    showSideText: "Sağ-sol yazıyı göster",
    showBusiness: "Kurum adını göster",
    showFooter: "Alt açıklamayı göster",
    showDecor: "Dekor efektini göster",
    centerLogo: "Orta logo yükle",
    removeLogo: "Logoyu kaldır",
    howToUse: "Nasıl kullanılır?",
    notes: [
      "Şablon tipini seçin: muhtarlık, dernek, uygulama veya QR Menü.",
      "Başlık, kurum adı, alt açıklama ve dikey yazıları istediğiniz gibi değiştirin.",
      "QR linki otomatik kurum linkinden gelir; isterseniz özel link yazabilirsiniz.",
      "PNG 3000x3000 px baskı için, SVG ise Canva / Illustrator / Corel için uygundur.",
    ],
    printNote:
      "Not: QR kodun okunabilir kalması için orta logoyu çok büyük kullanmayın. Sistem logoyu güvenli ölçüde tutar.",
    defaultLinkInfo: "Varsayılan link formatı",
    institutionIdentity: "Aktif Kurum Bilgileri",
    institutionCode: "Kurum Kodu",
    institutionId: "Kurum ID",
    institutionIdentityNote:
      "Kurum kodunuzu ayrıca BAYİLİK menüsünden görebilirsiniz.",
    institutionDataMissing:
      "Kurum bilgisi alınamadı. Sayfayı yenileyin veya BAYİLİK menüsündeki kurum bilgilerinizi kontrol edin.",
  },
  en: {
    title: "Professional QR Code Generator",
    subtitle:
      "Create professional print templates for QR menu, municipality, associations, app download and custom links.",
    loading: "Loading...",
    qrPreview: "QR Preview",
    qrLink: "QR Link",
    customUrlLabel: "Target link for QR code",
    customUrlPlaceholder: "Enter your institution link here",
    reset: "Back to institution link",
    copy: "Copy Link",
    copied: "Copied!",
    share: "Share",
    downloadQr: "Download QR",
    printTitle: "Professional Print Template",
    printSubtitle:
      "Export 3000x3000 px PNG or vector SVG for municipality, associations, restaurants, apps and custom use.",
    downloadPng: "Download Print PNG",
    downloadSvg: "Download Vector SVG",
    templateType: "Template Type",
    settings: "Template Settings",
    textSettings: "Text Fields",
    colorSettings: "Color Settings",
    logoSettings: "Center Logo",
    templateMenu: "QR Menu / Table",
    templateMuhtar: "Municipality",
    templateDernek: "Association",
    templateApp: "Google Play / App Store",
    templateSimple: "Clean Custom QR",
    businessName: "Institution / Brand Name",
    titleLine1: "Top title 1",
    titleLine2: "Top title 2",
    sideText: "Side vertical text",
    footerText: "Bottom description",
    bgColor: "Main background",
    accentColor: "Frame / accent",
    qrBgColor: "QR area color",
    textColor: "Text color",
    showTitle: "Show top title",
    showSideText: "Show side text",
    showBusiness: "Show institution name",
    showFooter: "Show bottom description",
    showDecor: "Show decoration effect",
    centerLogo: "Upload center logo",
    removeLogo: "Remove logo",
    howToUse: "How to use?",
    notes: [
      "Select a template type: municipality, association, app or QR menu.",
      "Edit the title, institution name, bottom text and side text freely.",
      "The QR link comes from the institution link automatically; you can also enter a custom link.",
      "PNG is 3000x3000 px for print, SVG is suitable for Canva / Illustrator / Corel.",
    ],
    printNote:
      "Note: Do not use a very large center logo so the QR remains readable. The system keeps the logo at a safe size.",
    defaultLinkInfo: "Default link format",
    institutionIdentity: "Active Institution Information",
    institutionCode: "Institution Code",
    institutionId: "Institution ID",
    institutionIdentityNote:
      "You can also find your institution code in the DEALERSHIP menu.",
    institutionDataMissing:
      "Institution information could not be loaded. Refresh the page or check it in the DEALERSHIP menu.",
  },
  de: {
    title: "Professioneller QR-Code Generator",
    subtitle:
      "Erstellen Sie professionelle Druckvorlagen für QR-Menü, Gemeinde, Vereine, App-Download und eigene Links.",
    loading: "Wird geladen...",
    qrPreview: "QR Vorschau",
    qrLink: "QR-Link",
    customUrlLabel: "Ziel-Link für den QR-Code",
    customUrlPlaceholder: "Institutionslink hier eingeben",
    reset: "Zurück zum Institutionslink",
    copy: "Link kopieren",
    copied: "Kopiert!",
    share: "Teilen",
    downloadQr: "QR herunterladen",
    printTitle: "Professionelle Druckvorlage",
    printSubtitle:
      "Exportieren Sie 3000x3000 px PNG oder SVG-Vektor für Gemeinde, Vereine, Restaurants, Apps und Speziallinks.",
    downloadPng: "Druck-PNG herunterladen",
    downloadSvg: "SVG-Vektor herunterladen",
    templateType: "Vorlagentyp",
    settings: "Vorlagen-Einstellungen",
    textSettings: "Textfelder",
    colorSettings: "Farbeinstellungen",
    logoSettings: "Logo in der Mitte",
    templateMenu: "QR-Menü / Tisch",
    templateMuhtar: "Gemeinde",
    templateDernek: "Verein",
    templateApp: "Google Play / App Store",
    templateSimple: "Sauberer Spezial-QR",
    businessName: "Institution / Markenname",
    titleLine1: "Titel oben 1",
    titleLine2: "Titel oben 2",
    sideText: "Seitlicher vertikaler Text",
    footerText: "Beschreibung unten",
    bgColor: "Haupthintergrund",
    accentColor: "Rahmen / Akzent",
    qrBgColor: "QR-Flächenfarbe",
    textColor: "Textfarbe",
    showTitle: "Titel oben anzeigen",
    showSideText: "Seitentext anzeigen",
    showBusiness: "Institutionsnamen anzeigen",
    showFooter: "Beschreibung unten anzeigen",
    showDecor: "Dekor-Effekt anzeigen",
    centerLogo: "Logo hochladen",
    removeLogo: "Logo entfernen",
    howToUse: "Wie verwenden?",
    notes: [
      "Wählen Sie einen Vorlagentyp: Gemeinde, Verein, App oder QR-Menü.",
      "Bearbeiten Sie Titel, Institutionsnamen, unteren Text und Seitentext frei.",
      "Der QR-Link wird automatisch vom Institutionslink übernommen; Sie können auch einen Speziallink eingeben.",
      "PNG ist 3000x3000 px für Druck, SVG ist für Canva / Illustrator / Corel geeignet.",
    ],
    printNote:
      "Hinweis: Verwenden Sie kein zu großes Logo in der Mitte, damit der QR lesbar bleibt. Das System hält das Logo sicher klein.",
    defaultLinkInfo: "Standard-Linkformat",
    institutionIdentity: "Aktive Institutionsdaten",
    institutionCode: "Institutionscode",
    institutionId: "Institutions-ID",
    institutionIdentityNote:
      "Ihren Institutionscode finden Sie auch im HÄNDLER-Menü.",
    institutionDataMissing:
      "Institutionsdaten konnten nicht geladen werden. Aktualisieren Sie die Seite oder prüfen Sie das HÄNDLER-Menü.",
  },
};

/* =========================
   PAYLAŞIM BAĞLANTILARI AÇIKLAMALARI
========================= */
const guideText = {
  tr: {
    eyebrow: "PAYLAŞIM BAĞLANTILARI",
    title: "Hangi bağlantıyı paylaşmalıyım?",
    subtitle:
      "Kurumunuza ait bağlantıyı veya QR kodunu WhatsApp, sosyal medya, afiş ya da kartvizit üzerinden paylaşın. Aşağıdaki renkli bölümler her bağlantının ne işe yaradığını açıklar.",
    shareFriend: "Arkadaşıma Gönder",
    copyLink: "Linki Kopyala",
    copied: "Kopyalandı",
    prepareQr: "Bu Link İçin QR Hazırla",
    ready: "QR alanına aktarıldı",
    unavailable: "Kurum bilgisi bekleniyor",
    missingCode:
      "Bu bağlantının hazırlanabilmesi için kurum kodu gereklidir. Kurum kodunuzu BAYİLİK menüsünden kontrol edebilirsiniz.",
    missingId:
      "Bu bağlantının hazırlanabilmesi için kurum ID bilgisi gereklidir. Sayfayı yenileyip tekrar deneyin.",
    items: {
      follow: {
        title: "Kurum Takip ve Mobil Uygulama Linki",
        tag: "App Store / Google Play",
        description:
          "Muhtarlık, dernek, diş hekimi, spor kulübü veya işletme bu bağlantıyı ya da QR kodunu paylaşır. Kodu okutan kişi cihazına göre App Store veya Google Play’e yönlenir, MesYat Dijital’i indirir ve ilgili kurumu doğrudan takip eder.",
        steps: [
          "Bağlantıyı veya QR kodunu WhatsApp’tan paylaşın.",
          "Kullanıcı kodu telefonuyla okutsun.",
          "Uygulamayı indirip kurumun duyuru ve etkinliklerini takip etsin.",
        ],
        shareText: "Kurumumuzu MesYat Dijital uygulamasından takip etmek için bağlantıyı açın:",
      },
      menu: {
        title: "QR Menü ve Dijital Menü Linki",
        tag: "Uygulama İndirmeden Görüntüle",
        description:
          "Restoran, kafe, otel, dernek lokali veya ürün/hizmet listesi kullanan kurum bu linki paylaşır. Bağlantıyı açan kişi uygulama indirmeden dijital menüyü ve yayınlanan içerikleri doğrudan görür.",
        steps: [
          "Linki masaya, vitrine, afişe veya sosyal medyaya ekleyin.",
          "Ziyaretçi QR kodu okutsun.",
          "Menü, fiyatlar ve kurumun yayınladığı bilgiler hemen açılsın.",
        ],
        shareText: "Dijital menümüzü görüntülemek için bağlantıyı açın:",
      },
      beauty: {
        title: "Kuaför ve Güzellik Salonu Tanıtım Linki",
        tag: "Hizmetler ve Randevu",
        description:
          "Kuaför veya güzellik salonu bu linki ya da QR kodunu müşterileriyle paylaşır. Bağlantıyı açan kişi salon bilgilerini, hizmetleri ve yayındaki randevu seçeneklerini doğrudan görür.",
        steps: [
          "Bağlantıyı Instagram, WhatsApp veya kartvizitte paylaşın.",
          "Müşteri QR kodu okutsun.",
          "Salonun bilgilerini, hizmetlerini ve randevu alanını görüntülesin.",
        ],
        shareText: "Güzellik salonumuzun hizmet ve bilgilerini görmek için bağlantıyı açın:",
      },
      cemetery: {
        title: "QR Mezarlık ve Dijital Anıt Görünüm Linki",
        tag: "Biyografi, Galeri ve Anılar",
        description:
          "QR mezarlık kaydı oluşturulduktan sonra bu bağlantı veya üretilen QR kod paylaşılır. Kodu okutan kişi dijital anıt sayfasındaki biyografi, fotoğraf, video, dua ve anı içeriklerini görür.",
        steps: [
          "Önce panelden dijital anıt kaydını oluşturun.",
          "Oluşan bağlantıyı veya QR kodunu paylaşın.",
          "Ziyaretçiler dijital anıt görünümünü doğrudan açsın.",
        ],
        shareText: "Dijital anıt sayfasını görüntülemek için bağlantıyı açın:",
      },
    },
  },
  en: {
    eyebrow: "SHARING LINKS",
    title: "Which link should I share?",
    subtitle:
      "Share your institution link or QR code through WhatsApp, social media, posters or business cards. Each colored section explains what the link does.",
    shareFriend: "Send to a Friend",
    copyLink: "Copy Link",
    copied: "Copied",
    prepareQr: "Prepare QR for This Link",
    ready: "Added to QR area",
    unavailable: "Waiting for institution information",
    missingCode:
      "The institution code is required for this link. You can check it in the DEALERSHIP menu.",
    missingId:
      "The institution ID is required for this link. Refresh the page and try again.",
    items: {
      follow: {
        title: "Institution Follow and Mobile App Link",
        tag: "App Store / Google Play",
        description:
          "Share this link or QR code for a municipality, association, clinic, sports club or business. The visitor is directed to the correct app store, installs MesYat Digital and follows the institution directly.",
        steps: ["Share the link or QR code.", "The visitor scans it by phone.", "They install the app and follow announcements and events."],
        shareText: "Open this link to follow our institution in MesYat Digital:",
      },
      menu: {
        title: "QR Menu and Digital Menu Link",
        tag: "View Without Installing",
        description:
          "Restaurants, cafes, hotels and institutions can share this link. Visitors see the digital menu and published information directly without installing the app.",
        steps: ["Place the link on tables, posters or social media.", "The visitor scans the QR code.", "The menu and prices open immediately."],
        shareText: "Open our digital menu:",
      },
      beauty: {
        title: "Beauty Salon Presentation Link",
        tag: "Services and Appointments",
        description:
          "Beauty salons and hairdressers share this link so customers can view salon information, services and available appointment options.",
        steps: ["Share it on Instagram, WhatsApp or a business card.", "The customer scans the QR code.", "They view services and appointment information."],
        shareText: "Open the link to see our salon services:",
      },
      cemetery: {
        title: "QR Cemetery and Digital Memorial Link",
        tag: "Biography, Gallery and Memories",
        description:
          "After creating a digital memorial, share this link or QR code. Visitors can view the biography, photos, videos, prayers and memories.",
        steps: ["Create the digital memorial first.", "Share its link or QR code.", "Visitors open the memorial page directly."],
        shareText: "Open the digital memorial page:",
      },
    },
  },
  de: {
    eyebrow: "FREIGABELINKS",
    title: "Welchen Link soll ich teilen?",
    subtitle:
      "Teilen Sie den Institutionslink oder QR-Code über WhatsApp, soziale Medien, Plakate oder Visitenkarten. Jeder farbige Bereich erklärt die Funktion.",
    shareFriend: "An Freund senden",
    copyLink: "Link kopieren",
    copied: "Kopiert",
    prepareQr: "QR für diesen Link vorbereiten",
    ready: "In den QR-Bereich übernommen",
    unavailable: "Institutionsdaten werden erwartet",
    missingCode:
      "Für diesen Link wird der Institutionscode benötigt. Sie finden ihn im HÄNDLER-Menü.",
    missingId:
      "Für diesen Link wird die Institutions-ID benötigt. Aktualisieren Sie die Seite und versuchen Sie es erneut.",
    items: {
      follow: {
        title: "Institution folgen und Mobile-App-Link",
        tag: "App Store / Google Play",
        description:
          "Gemeinden, Vereine, Praxen, Sportclubs und Unternehmen teilen diesen Link. Besucher installieren MesYat Digital und folgen der Institution direkt.",
        steps: ["Link oder QR-Code teilen.", "Besucher scannt den Code.", "App installieren und Meldungen sowie Veranstaltungen verfolgen."],
        shareText: "Öffnen Sie diesen Link, um unserer Institution in MesYat Digital zu folgen:",
      },
      menu: {
        title: "QR-Menü und digitales Menü",
        tag: "Ohne Installation ansehen",
        description:
          "Restaurants, Cafés, Hotels und Institutionen teilen diesen Link. Besucher sehen Menü, Preise und veröffentlichte Informationen ohne App-Installation.",
        steps: ["Link auf Tisch, Plakat oder Social Media platzieren.", "QR-Code scannen.", "Menü und Preise werden sofort geöffnet."],
        shareText: "Öffnen Sie unser digitales Menü:",
      },
      beauty: {
        title: "Friseur- und Schönheitssalon-Link",
        tag: "Leistungen und Termine",
        description:
          "Salons teilen diesen Link, damit Kunden Informationen, Leistungen und verfügbare Terminoptionen direkt sehen können.",
        steps: ["Auf Instagram, WhatsApp oder Visitenkarte teilen.", "Kunde scannt den QR-Code.", "Leistungen und Termine ansehen."],
        shareText: "Öffnen Sie den Link zu unseren Salonleistungen:",
      },
      cemetery: {
        title: "QR-Friedhof und digitale Gedenkseite",
        tag: "Biografie, Galerie und Erinnerungen",
        description:
          "Nach Erstellung der digitalen Gedenkseite wird dieser Link oder QR-Code geteilt. Besucher sehen Biografie, Fotos, Videos, Gebete und Erinnerungen.",
        steps: ["Digitale Gedenkseite erstellen.", "Link oder QR-Code teilen.", "Besucher öffnen die Gedenkseite direkt."],
        shareText: "Öffnen Sie die digitale Gedenkseite:",
      },
    },
  },
};

/* =========================
   VARSAYILAN LINK
========================= */
const DEFAULT_MENU_LINK = "";

/* =========================
   PANEL OTURUMU VE DİLİ
   BayilikSistemi.js ile aynı localStorage sırası
========================= */
function getPanelLanguage() {
  const raw =
    localStorage.getItem("panel_dili") ||
    localStorage.getItem("app_lang") ||
    localStorage.getItem("lang") ||
    "tr";

  const language = String(raw).slice(0, 2).toLowerCase();
  return ["tr", "en", "de"].includes(language) ? language : "tr";
}

function getAuthToken() {
  return (
    localStorage.getItem("token") ||
    localStorage.getItem("user_token") ||
    localStorage.getItem("auth_token") ||
    ""
  );
}

/* =========================
   HAZIR PROFESYONEL ŞABLONLAR
========================= */
const templatePresets = {
  tr: {
    menu: {
      key: "menu",
      business: "MESYAT",
      title1: "QR MENÜ İÇİN",
      title2: "OKUTUNUZ",
      side: "MASA",
      footer: "QR Menü için Instagram @mesyatdiji",
      bg: "#09086B",
      accent: "#ffffff",
      qrBg: "#ffffff",
      text: "#ffffff",
      showTitle: true,
      showSideText: true,
      showBusiness: true,
      showFooter: true,
      showDecor: true,
    },
    muhtar: {
      key: "muhtar",
      business: "MUHTARLIĞIMIZ",
      title1: "MUHTARLIĞIMIZI",
      title2: "TAKİP EDELİM",
      side: "MUHTARLIK",
      footer: "Duyuru, etkinlik ve bilgilendirmeler için QR kodu okutunuz",
      bg: "#0B2A5B",
      accent: "#F59E0B",
      qrBg: "#ffffff",
      text: "#ffffff",
      showTitle: true,
      showSideText: true,
      showBusiness: true,
      showFooter: true,
      showDecor: true,
    },
    dernek: {
      key: "dernek",
      business: "DERNEĞİMİZ",
      title1: "DERNEĞİMİZİ",
      title2: "DESTEKLEYİN",
      side: "DERNEK",
      footer: "Google Play ve App Store üzerinden QR kodu okutarak destek olunuz",
      bg: "#102A43",
      accent: "#38BDF8",
      qrBg: "#ffffff",
      text: "#ffffff",
      showTitle: true,
      showSideText: true,
      showBusiness: true,
      showFooter: true,
      showDecor: true,
    },
    app: {
      key: "app",
      business: "MOBİL UYGULAMA",
      title1: "UYGULAMAMIZI",
      title2: "İNDİRİN",
      side: "APP",
      footer: "Google Play ve App Store için QR kodu okutunuz",
      bg: "#111827",
      accent: "#F97316",
      qrBg: "#ffffff",
      text: "#ffffff",
      showTitle: true,
      showSideText: true,
      showBusiness: true,
      showFooter: true,
      showDecor: true,
    },
    simple: {
      key: "simple",
      business: "",
      title1: "",
      title2: "",
      side: "",
      footer: "",
      bg: "#111514",
      accent: "#F97316",
      qrBg: "#ffffff",
      text: "#ffffff",
      showTitle: false,
      showSideText: false,
      showBusiness: false,
      showFooter: false,
      showDecor: true,
    },
  },

  en: {
    menu: {
      key: "menu",
      business: "MESYAT",
      title1: "SCAN FOR",
      title2: "QR MENU",
      side: "TABLE",
      footer: "For QR Menu Instagram @mesyatdiji",
      bg: "#09086B",
      accent: "#ffffff",
      qrBg: "#ffffff",
      text: "#ffffff",
      showTitle: true,
      showSideText: true,
      showBusiness: true,
      showFooter: true,
      showDecor: true,
    },
    muhtar: {
      key: "muhtar",
      business: "MUNICIPALITY",
      title1: "FOLLOW OUR",
      title2: "ANNOUNCEMENTS",
      side: "LOCAL",
      footer: "Scan the QR code for announcements and updates",
      bg: "#0B2A5B",
      accent: "#F59E0B",
      qrBg: "#ffffff",
      text: "#ffffff",
      showTitle: true,
      showSideText: true,
      showBusiness: true,
      showFooter: true,
      showDecor: true,
    },
    dernek: {
      key: "dernek",
      business: "ASSOCIATION",
      title1: "SUPPORT OUR",
      title2: "ASSOCIATION",
      side: "HELP",
      footer: "Scan the QR code to support us on Google Play and App Store",
      bg: "#102A43",
      accent: "#38BDF8",
      qrBg: "#ffffff",
      text: "#ffffff",
      showTitle: true,
      showSideText: true,
      showBusiness: true,
      showFooter: true,
      showDecor: true,
    },
    app: {
      key: "app",
      business: "MOBILE APP",
      title1: "DOWNLOAD",
      title2: "OUR APP",
      side: "APP",
      footer: "Scan the QR code for Google Play and App Store",
      bg: "#111827",
      accent: "#F97316",
      qrBg: "#ffffff",
      text: "#ffffff",
      showTitle: true,
      showSideText: true,
      showBusiness: true,
      showFooter: true,
      showDecor: true,
    },
    simple: {
      key: "simple",
      business: "",
      title1: "",
      title2: "",
      side: "",
      footer: "",
      bg: "#111514",
      accent: "#F97316",
      qrBg: "#ffffff",
      text: "#ffffff",
      showTitle: false,
      showSideText: false,
      showBusiness: false,
      showFooter: false,
      showDecor: true,
    },
  },

  de: {
    menu: {
      key: "menu",
      business: "MESYAT",
      title1: "QR-MENÜ",
      title2: "SCANNEN",
      side: "TISCH",
      footer: "Für QR-Menü Instagram @mesyatdiji",
      bg: "#09086B",
      accent: "#ffffff",
      qrBg: "#ffffff",
      text: "#ffffff",
      showTitle: true,
      showSideText: true,
      showBusiness: true,
      showFooter: true,
      showDecor: true,
    },
    muhtar: {
      key: "muhtar",
      business: "GEMEINDE",
      title1: "UNSERE",
      title2: "MITTEILUNGEN",
      side: "INFO",
      footer: "Scannen Sie den QR-Code für Bekanntmachungen und Informationen",
      bg: "#0B2A5B",
      accent: "#F59E0B",
      qrBg: "#ffffff",
      text: "#ffffff",
      showTitle: true,
      showSideText: true,
      showBusiness: true,
      showFooter: true,
      showDecor: true,
    },
    dernek: {
      key: "dernek",
      business: "VEREIN",
      title1: "UNSEREN",
      title2: "VEREIN UNTERSTÜTZEN",
      side: "HILFE",
      footer: "Scannen Sie den QR-Code zur Unterstützung über Google Play und App Store",
      bg: "#102A43",
      accent: "#38BDF8",
      qrBg: "#ffffff",
      text: "#ffffff",
      showTitle: true,
      showSideText: true,
      showBusiness: true,
      showFooter: true,
      showDecor: true,
    },
    app: {
      key: "app",
      business: "MOBILE APP",
      title1: "APP",
      title2: "HERUNTERLADEN",
      side: "APP",
      footer: "QR-Code für Google Play und App Store scannen",
      bg: "#111827",
      accent: "#F97316",
      qrBg: "#ffffff",
      text: "#ffffff",
      showTitle: true,
      showSideText: true,
      showBusiness: true,
      showFooter: true,
      showDecor: true,
    },
    simple: {
      key: "simple",
      business: "",
      title1: "",
      title2: "",
      side: "",
      footer: "",
      bg: "#111514",
      accent: "#F97316",
      qrBg: "#ffffff",
      text: "#ffffff",
      showTitle: false,
      showSideText: false,
      showBusiness: false,
      showFooter: false,
      showDecor: true,
    },
  },
};

/* =========================
   ANA COMPONENT
========================= */
export default function QrKodPage() {
  const [uiLang, setUiLang] = useState(getPanelLanguage);

  const TT = t[uiLang] || t.tr;
  const GUIDE = guideText[uiLang] || guideText.tr;

  const [institution, setInstitution] = useState(null);
  const [loading, setLoading] = useState(true);
  const [institutionError, setInstitutionError] = useState("");
  const [copied, setCopied] = useState(false);
  const [openGuideKey, setOpenGuideKey] = useState("follow");
  const [guideCopied, setGuideCopied] = useState("");
  const [guideReady, setGuideReady] = useState("");

  const [defaultMenuLink, setDefaultMenuLink] = useState(DEFAULT_MENU_LINK);
  const [qrValue, setQrValue] = useState(DEFAULT_MENU_LINK);
  const [customUrl, setCustomUrl] = useState(DEFAULT_MENU_LINK);
  const [useCustomUrl, setUseCustomUrl] = useState(false);

  const [templateType, setTemplateType] = useState("menu");

  const [printBusinessName, setPrintBusinessName] = useState("MESYAT");
  const [titleLine1, setTitleLine1] = useState("QR MENÜ İÇİN");
  const [titleLine2, setTitleLine2] = useState("OKUTUNUZ");
  const [sideText, setSideText] = useState("MASA");
  const [footerText, setFooterText] = useState(
    "QR Menü için Instagram @mesyatdiji"
  );

  const [backgroundColor, setBackgroundColor] = useState("#09086B");
  const [accentColor, setAccentColor] = useState("#ffffff");
  const [qrAreaColor, setQrAreaColor] = useState("#ffffff");
  const [textColor, setTextColor] = useState("#ffffff");

  const [showTitle, setShowTitle] = useState(true);
  const [showSideText, setShowSideText] = useState(true);
  const [showBusiness, setShowBusiness] = useState(true);
  const [showFooter, setShowFooter] = useState(true);
  const [showDecor, setShowDecor] = useState(true);

  const [centerLogoDataUrl, setCenterLogoDataUrl] = useState("");

  const qrRef = useRef(null);

  useEffect(() => {
    loadInstitutionData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    localStorage.setItem("panel_dili", uiLang);
    localStorage.setItem("app_lang", uiLang);
    localStorage.setItem("lang", uiLang);
  }, [uiLang]);

  /* =========================
     KURUM BİLGİSİ
  ========================= */
  const loadInstitutionData = async () => {
    try {
      const token = getAuthToken();

      if (!token) {
        setInstitutionError(TT.institutionDataMissing);
        setLoading(false);
        return;
      }

      const authHeaders = { Authorization: `Bearer ${token}` };
      const getJson = async (url) => {
        try {
          const response = await fetch(url, { headers: authHeaders });
          if (!response.ok) return null;
          return await response.json();
        } catch (error) {
          console.warn(`Kurum veri kaynağına ulaşılamadı: ${url}`, error);
          return null;
        }
      };

      /*
       * BayilikSistemi ile aynı ana kaynak kullanılır.
       * auth/me yalnızca profil adı, logo ve güvenli alan yedeğidir.
       */
      const [dashboardResponse, profileResponse] = await Promise.all([
        getJson(`${API_BASE}/bayilik/my-dashboard`),
        getJson(`${API_BASE}/auth/me`),
      ]);

      const dashboard = dashboardResponse?.data || dashboardResponse || {};
      const profile = profileResponse?.data || profileResponse || {};
      const partner = dashboard?.partner || {};
      const inviteLink =
        dashboard?.davet_linki || dashboardResponse?.davet_linki || {};
      const profileInstitution =
        profile?.kurum || profile?.institution || profile?.company || {};
      const records =
        dashboard?.islemler ||
        dashboardResponse?.islemler ||
        dashboard?.sales ||
        dashboardResponse?.sales ||
        [];
      const institutionRecord = Array.isArray(records)
        ? records.find(
            (row) =>
              row?.kurum_id ||
              row?.kurum_short_code ||
              row?.kurum_code
          ) || {}
        : {};

      const tokenPayload = (() => {
        try {
          const payload = token.split(".")[1];
          if (!payload) return {};
          const normalized = payload.replace(/-/g, "+").replace(/_/g, "/");
          const padded = normalized.padEnd(
            normalized.length + ((4 - (normalized.length % 4)) % 4),
            "="
          );
          const binary = window.atob(padded);
          const bytes = Uint8Array.from(binary, (character) =>
            character.charCodeAt(0)
          );
          return JSON.parse(new TextDecoder().decode(bytes));
        } catch (error) {
          return {};
        }
      })();

      const firstValue = (...values) =>
        values.find(
          (value) =>
            value !== undefined &&
            value !== null &&
            String(value).trim() !== ""
        );

      const kurumId = firstValue(
        tokenPayload?.kurum_id,
        tokenPayload?.company_id,
        tokenPayload?.business_id,
        partner?.kurum_id,
        institutionRecord?.kurum_id,
        profile?.kurum_id,
        profileInstitution?.kurum_id,
        profileInstitution?.id
      );

      const explicitPartnerCode = firstValue(
        partner?.kurum_short_code,
        partner?.short_code,
        partner?.kurum_code
      );
      const genericPartnerCode = firstValue(partner?.code);
      const safePartnerCode =
        genericPartnerCode !== undefined &&
        String(genericPartnerCode) !== String(kurumId ?? "")
          ? genericPartnerCode
          : undefined;

      const kurumMenuKodu = firstValue(
        inviteLink?.ref_code,
        institutionRecord?.kurum_short_code,
        institutionRecord?.kurum_code,
        explicitPartnerCode,
        safePartnerCode,
        profileInstitution?.short_code,
        profileInstitution?.kurum_short_code,
        profileInstitution?.kurum_kodu,
        profileInstitution?.code,
        profile?.kurum_short_code,
        profile?.short_code,
        profile?.kurum_kodu,
        profile?.menu_kodu
      );

      const kurumAdi = firstValue(
        institutionRecord?.kurum_adi,
        partner?.kurum_adi,
        profileInstitution?.ad,
        profileInstitution?.kurum_adi,
        profile?.kurum_adi
      ) || "";

      const menuLink = kurumMenuKodu
        ? `https://panel.haymestasarim.com/#/menu/${kurumMenuKodu}`
        : "";

      const kurumData = {
        id: kurumId || null,
        kurum_id: kurumId || null,
        ad: kurumAdi,
        code: kurumMenuKodu || "",
        short_code: kurumMenuKodu || "",
        logo_url:
          profileInstitution?.logo_url ||
          profileInstitution?.logo ||
          profile?.logo_url ||
          profile?.logo ||
          null,
      };

      setInstitution(kurumData);
      setInstitutionError(
        kurumId || kurumMenuKodu ? "" : TT.institutionDataMissing
      );
      setDefaultMenuLink(menuLink);
      setQrValue(menuLink);
      setCustomUrl(menuLink);
      setUseCustomUrl(false);

      if (kurumAdi) {
        setPrintBusinessName(String(kurumAdi).toUpperCase());
      }
    } catch (error) {
      console.error("❌ Kurum bilgileri yüklenemedi:", error);
      setInstitutionError(TT.institutionDataMissing);
    } finally {
      setLoading(false);
    }
  };

  /* =========================
     ŞABLON UYGULA
  ========================= */
  const applyTemplate = (key) => {
    const preset =
      templatePresets?.[uiLang]?.[key] || templatePresets.tr[key] || null;

    if (!preset) return;

    setTemplateType(key);

    if (key === "menu" && institution?.ad) {
      setPrintBusinessName(String(institution.ad).toUpperCase());
    } else {
      setPrintBusinessName(preset.business);
    }

    setTitleLine1(preset.title1);
    setTitleLine2(preset.title2);
    setSideText(preset.side);
    setFooterText(preset.footer);

    setBackgroundColor(preset.bg);
    setAccentColor(preset.accent);
    setQrAreaColor(preset.qrBg);
    setTextColor(preset.text);

    setShowTitle(preset.showTitle);
    setShowSideText(preset.showSideText);
    setShowBusiness(preset.showBusiness);
    setShowFooter(preset.showFooter);
    setShowDecor(preset.showDecor);
  };

  /* =========================
     URL İŞLEMLERİ
  ========================= */
  const handleCustomUrlChange = (e) => {
    const url = e.target.value;
    setCustomUrl(url);

    if (url.trim() !== "") {
      setUseCustomUrl(url.trim() !== defaultMenuLink.trim());
      setQrValue(url.trim());
    } else {
      setUseCustomUrl(true);
      setQrValue(" ");
    }
  };

  const resetToInstitutionLink = () => {
    const link = defaultMenuLink;
    setQrValue(link);
    setCustomUrl(link);
    setUseCustomUrl(false);
  };

  const writeToClipboard = async (value) => {
    const text = String(value || "");

    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return;
    }

    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed";
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
  };

  const copyToClipboard = async () => {
    if (!qrValue?.trim()) return;

    try {
      await writeToClipboard(qrValue || "");
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error("Link kopyalanamadı:", error);
    }
  };

  const shareQR = async () => {
    if (!qrValue?.trim()) return;

    if (navigator.share) {
      try {
        await navigator.share({
          title: useCustomUrl ? "Özel QR Kod" : "QR Kod",
          text: qrValue,
          url: qrValue,
        });
      } catch (err) {
        console.log("Paylaşım iptal edildi");
      }
    } else {
      copyToClipboard();
    }
  };

  const copyGuideLink = async (item) => {
    if (!item?.url) return;

    try {
      await writeToClipboard(item.url);
      setGuideCopied(item.key);
      setTimeout(() => setGuideCopied(""), 2200);
    } catch (error) {
      console.error("Paylaşım linki kopyalanamadı:", error);
    }
  };

  const shareGuideLink = async (item) => {
    if (!item?.url) return;

    const message = `${item.shareText}\n${item.url}`;

    if (navigator.share) {
      try {
        await navigator.share({
          title: item.title,
          text: item.shareText,
          url: item.url,
        });
        return;
      } catch (error) {
        if (error?.name === "AbortError") return;
      }
    }

    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
    const opened = window.open(whatsappUrl, "_blank", "noopener,noreferrer");

    if (!opened) {
      await copyGuideLink(item);
    }
  };

  const prepareGuideQr = (item) => {
    if (!item?.url) return;

    setQrValue(item.url);
    setCustomUrl(item.url);
    setUseCustomUrl(item.url !== defaultMenuLink);
    setGuideReady(item.key);
    setTimeout(() => setGuideReady(""), 2200);
  };

  /* =========================
     DOSYA ADI
  ========================= */
  const safeFileName = (value) => {
    return String(value || "qr-kod")
      .toLowerCase()
      .replace(/ğ/g, "g")
      .replace(/ü/g, "u")
      .replace(/ş/g, "s")
      .replace(/ı/g, "i")
      .replace(/ö/g, "o")
      .replace(/ç/g, "c")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .slice(0, 70);
  };

  const escapeXml = (value = "") => {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&apos;");
  };

  const wrapText = (value = "", maxChars = 46, maxLines = 2) => {
    const text = String(value || "").replace(/\s+/g, " ").trim();
    if (!text) return [];

    const words = text.split(" ");
    const lines = [];
    let current = "";

    words.forEach((word) => {
      const test = current ? `${current} ${word}` : word;
      if (test.length <= maxChars) {
        current = test;
      } else {
        if (current) lines.push(current);
        current = word;
      }
    });

    if (current) lines.push(current);

    return lines.slice(0, maxLines);
  };

  const getVerticalLetters = (value = "") => {
    const clean = String(value || "")
      .replace(/\s+/g, "")
      .toUpperCase()
      .slice(0, 10);

    if (!clean) return [];

    return clean.split("");
  };

  /* =========================
     QR SOURCE
  ========================= */
  const getQrSource = () => {
    const qrElement = document.getElementById("qr-code-print-source");

    const qrInner = qrElement?.innerHTML || "";
    const qrViewBox =
      qrElement?.getAttribute("viewBox") ||
      `0 0 ${qrElement?.getAttribute("width") || 900} ${
        qrElement?.getAttribute("height") || 900
      }`;

    return { qrInner, qrViewBox };
  };

  const buildLogoSvg = (x, y, size, circleFill = "#ffffff") => {
    if (!centerLogoDataUrl) return "";

    const cx = x + size / 2;
    const cy = y + size / 2;

    return `
      <circle cx="${cx}" cy="${cy}" r="${
      size / 2 + 34
    }" fill="${escapeXml(circleFill)}"/>
      <circle cx="${cx}" cy="${cy}" r="${
      size / 2 + 36
    }" fill="none" stroke="${escapeXml(accentColor)}" stroke-width="8" opacity="0.45"/>
      <clipPath id="centerLogoClip">
        <circle cx="${cx}" cy="${cy}" r="${size / 2}"/>
      </clipPath>
      <image href="${escapeXml(
        centerLogoDataUrl
      )}" x="${x}" y="${y}" width="${size}" height="${size}" preserveAspectRatio="xMidYMid slice" clip-path="url(#centerLogoClip)"/>
    `;
  };

  /* =========================
     SVG EXPORT TASARIMI
  ========================= */
  const buildProfessionalPrintSvg = () => {
    const { qrInner, qrViewBox } = getQrSource();

    const isSimple = templateType === "simple";
    const businessName = escapeXml(String(printBusinessName || "").toUpperCase());
    const top1 = escapeXml(titleLine1 || "");
    const top2 = escapeXml(titleLine2 || "");
    const footerLines = wrapText(footerText, 58, 2);

    const sideLetters = getVerticalLetters(sideText);
    const sideFontSize =
      sideLetters.length >= 9 ? 118 : sideLetters.length >= 7 ? 135 : 170;
    const sideGap =
      sideLetters.length >= 9 ? 145 : sideLetters.length >= 7 ? 165 : 210;
    const sideCenterY = 1500;
    const sideStartY =
      sideCenterY - ((sideLetters.length - 1) * sideGap) / 2 + sideFontSize / 3;

    const sideSvg =
      showSideText && sideLetters.length > 0 && !isSimple
        ? sideLetters
            .map((letter, index) => {
              const y = sideStartY + index * sideGap;

              return `
                <text x="500" y="${y}" text-anchor="middle" font-family="Arial, Helvetica, sans-serif" font-size="${sideFontSize}" font-weight="900" fill="${escapeXml(
                textColor
              )}" letter-spacing="1">${escapeXml(letter)}</text>
                <text x="2500" y="${y}" text-anchor="middle" font-family="Arial, Helvetica, sans-serif" font-size="${sideFontSize}" font-weight="900" fill="${escapeXml(
                textColor
              )}" letter-spacing="1">${escapeXml(letter)}</text>
              `;
            })
            .join("")
        : "";

    const titleSvg =
      showTitle && !isSimple
        ? `
          <text x="1500" y="385" text-anchor="middle" font-family="Arial, Helvetica, sans-serif" font-size="${
            titleLine1.length > 18 ? 128 : 155
          }" font-weight="900" fill="${escapeXml(textColor)}" letter-spacing="2">${top1}</text>
          <text x="1500" y="565" text-anchor="middle" font-family="Arial, Helvetica, sans-serif" font-size="${
            titleLine2.length > 18 ? 118 : 145
          }" font-weight="900" fill="${escapeXml(textColor)}" letter-spacing="2">${top2}</text>
        `
        : "";

    const businessSvg =
      showBusiness && businessName && !isSimple
        ? `
          <text x="1500" y="2470" text-anchor="middle" font-family="Arial, Helvetica, sans-serif" font-size="${
            businessName.length > 20 ? 120 : businessName.length > 13 ? 155 : 205
          }" font-weight="900" fill="${escapeXml(
            textColor
          )}" letter-spacing="3">${businessName}</text>
        `
        : "";

    const footerSvg =
      showFooter && footerLines.length > 0 && !isSimple
        ? footerLines
            .map((line, index) => {
              const y = 2665 + index * 105;
              return `
                <text x="1500" y="${y}" text-anchor="middle" font-family="Arial, Helvetica, sans-serif" font-size="${
                footerLines.length > 1 ? 70 : 82
              }" font-weight="800" fill="${escapeXml(textColor)}">${escapeXml(
                line
              )}</text>
              `;
            })
            .join("")
        : "";

    const decorSvg = showDecor
      ? `
        <circle cx="650" cy="620" r="240" fill="${escapeXml(
          accentColor
        )}" opacity="0.08"/>
        <circle cx="2350" cy="2390" r="290" fill="${escapeXml(
          accentColor
        )}" opacity="0.09"/>
        <circle cx="2450" cy="690" r="95" fill="${escapeXml(
          accentColor
        )}" opacity="0.16"/>
        <circle cx="555" cy="2350" r="105" fill="${escapeXml(
          accentColor
        )}" opacity="0.13"/>
      `
      : "";

    if (isSimple) {
      return `
<svg xmlns="http://www.w3.org/2000/svg" width="3000" height="3000" viewBox="0 0 3000 3000">
  <rect width="3000" height="3000" fill="#ffffff"/>
  <rect x="260" y="260" width="2480" height="2480" rx="360" ry="360" fill="${escapeXml(
    backgroundColor
  )}"/>
  <rect x="345" y="345" width="2310" height="2310" rx="310" ry="310" fill="none" stroke="${escapeXml(
    accentColor
  )}" stroke-width="18" opacity="0.55"/>
  ${decorSvg}
  <rect x="690" y="690" width="1620" height="1620" rx="90" fill="${escapeXml(
    qrAreaColor
  )}"/>
  <svg x="760" y="760" width="1480" height="1480" viewBox="${escapeXml(
    qrViewBox
  )}">
    ${qrInner}
  </svg>
  ${buildLogoSvg(1345, 1345, 310, qrAreaColor)}
</svg>`.trim();
    }

    return `
<svg xmlns="http://www.w3.org/2000/svg" width="3000" height="3000" viewBox="0 0 3000 3000">
  <rect width="3000" height="3000" fill="#ffffff"/>

  <rect x="235" y="170" width="2530" height="2660" rx="335" ry="335" fill="${escapeXml(
    backgroundColor
  )}"/>
  <rect x="285" y="220" width="2430" height="2560" rx="295" ry="295" fill="none" stroke="${escapeXml(
    accentColor
  )}" stroke-width="12" opacity="0.40"/>
  <rect x="330" y="265" width="2340" height="2470" rx="260" ry="260" fill="none" stroke="${escapeXml(
    accentColor
  )}" stroke-width="4" opacity="0.17"/>

  ${decorSvg}

  ${titleSvg}

  ${sideSvg}

  <rect x="710" y="710" width="1580" height="1580" rx="60" fill="${escapeXml(
    qrAreaColor
  )}"/>
  <rect x="740" y="740" width="1520" height="1520" rx="42" fill="#ffffff" opacity="0.96"/>

  <svg x="775" y="775" width="1450" height="1450" viewBox="${escapeXml(
    qrViewBox
  )}">
    ${qrInner}
  </svg>

  ${buildLogoSvg(1350, 1350, 300, qrAreaColor)}

  ${businessSvg}

  ${footerSvg}
</svg>`.trim();
  };

  /* =========================
     DOWNLOAD
  ========================= */
  const triggerDownload = (href, fileName) => {
    const downloadLink = document.createElement("a");
    downloadLink.href = href;
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  const downloadQR = () => {
    if (!qrValue?.trim()) return;

    const svgElement = document.getElementById("qr-code-canvas");

    if (!svgElement) {
      alert("QR kod bulunamadı!");
      return;
    }

    const svgData = new XMLSerializer().serializeToString(svgElement);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const size = 1200;

    canvas.width = size;
    canvas.height = size;

    const img = new Image();
    const svgBlob = new Blob([svgData], {
      type: "image/svg+xml;charset=utf-8",
    });

    const url = URL.createObjectURL(svgBlob);

    img.onload = () => {
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, size, size);

      const pngUrl = canvas.toDataURL("image/png");
      const code = institution?.short_code || institution?.code || "ozel";

      triggerDownload(
        pngUrl,
        `qr-${useCustomUrl ? "ozel-link" : code}.png`
      );

      URL.revokeObjectURL(url);
    };

    img.onerror = () => {
      URL.revokeObjectURL(url);
      alert("QR kod indirilemedi. Lütfen tekrar deneyin.");
    };

    img.src = url;
  };

  const downloadProfessionalPrintPNG = () => {
    if (!qrValue?.trim()) return;

    const svgData = buildProfessionalPrintSvg();

    const svgBlob = new Blob([svgData], {
      type: "image/svg+xml;charset=utf-8",
    });

    const url = URL.createObjectURL(svgBlob);
    const img = new Image();

    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      canvas.width = 3000;
      canvas.height = 3000;

      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      const pngUrl = canvas.toDataURL("image/png");

      const name = safeFileName(
        printBusinessName || templateType || institution?.short_code || "qr-kod"
      );

      triggerDownload(pngUrl, `${name}-profesyonel-qr-3000px.png`);
      URL.revokeObjectURL(url);
    };

    img.onerror = () => {
      URL.revokeObjectURL(url);
      alert("Baskı görseli oluşturulamadı. Lütfen tekrar deneyin.");
    };

    img.src = url;
  };

  const downloadProfessionalPrintSVG = () => {
    if (!qrValue?.trim()) return;

    const svgData = buildProfessionalPrintSvg();

    const svgBlob = new Blob([svgData], {
      type: "image/svg+xml;charset=utf-8",
    });

    const url = URL.createObjectURL(svgBlob);

    const name = safeFileName(
      printBusinessName || templateType || institution?.short_code || "qr-kod"
    );

    triggerDownload(url, `${name}-profesyonel-qr-vektor.svg`);

    setTimeout(() => {
      URL.revokeObjectURL(url);
    }, 500);
  };

  /* =========================
     LOGO UPLOAD
  ========================= */
  const handleLogoUpload = (e) => {
    const file = e.target.files?.[0];

    if (!file) return;

    const reader = new FileReader();

    reader.onload = () => {
      setCenterLogoDataUrl(String(reader.result || ""));
    };

    reader.readAsDataURL(file);
  };

  const templateButtons = [
    { key: "menu", label: TT.templateMenu, icon: "🍽️" },
    { key: "muhtar", label: TT.templateMuhtar, icon: "🏛️" },
    { key: "dernek", label: TT.templateDernek, icon: "🤝" },
    { key: "app", label: TT.templateApp, icon: "📱" },
    { key: "simple", label: TT.templateSimple, icon: "✨" },
  ];

  const institutionCode = institution?.short_code || institution?.code || "";
  const institutionId = institution?.kurum_id || institution?.id || "";

  const guideItems = [
    {
      key: "follow",
      icon: "📱",
      color: "#0B4D8B",
      soft: "#F1F6FB",
      deep: "#082F49",
      border: "#B7D0E5",
      url: institutionCode
        ? `https://panel.haymestasarim.com/q/${institutionCode}`
        : "",
      unavailableText: GUIDE.missingCode,
      ...GUIDE.items.follow,
    },
    {
      key: "menu",
      icon: "🍽️",
      color: "#B45309",
      soft: "#FFF8EE",
      deep: "#78350F",
      border: "#E8C89A",
      url: institutionCode ? defaultMenuLink : "",
      unavailableText: GUIDE.missingCode,
      ...GUIDE.items.menu,
    },
    {
      key: "beauty",
      icon: "✨",
      color: "#6D3BA8",
      soft: "#F7F3FB",
      deep: "#3B1D5A",
      border: "#CEBCE0",
      url: institutionId
        ? `https://panel.haymestasarim.com/#/beaty/${institutionId}`
        : "",
      unavailableText: GUIDE.missingId,
      ...GUIDE.items.beauty,
    },
    {
      key: "cemetery",
      icon: "🕊️",
      color: "#166534",
      soft: "#F2F8F4",
      deep: "#14532D",
      border: "#B8D4C2",
      url: institutionId
        ? `https://panel.haymestasarim.com/#/mezarliklar/${institutionId}`
        : "",
      unavailableText: GUIDE.missingId,
      ...GUIDE.items.cemetery,
    },
  ];

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-blue-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-orange-600 mx-auto"></div>
          <p className="mt-4 text-gray-700 font-semibold">{TT.loading}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="qr-page min-h-screen bg-gradient-to-br from-orange-50 via-white to-blue-50">
      <style>{`
        @keyframes qrFloat {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-8px); }
        }

        @keyframes qrGlow {
          0%, 100% { box-shadow: 0 24px 70px rgba(15, 23, 42, 0.20); }
          50% { box-shadow: 0 30px 90px rgba(249, 115, 22, 0.30); }
        }

        @keyframes shineMove {
          0% { transform: translateX(-140%) rotate(25deg); }
          100% { transform: translateX(180%) rotate(25deg); }
        }

        .qr-animated-card {
          animation: qrFloat 4s ease-in-out infinite, qrGlow 5s ease-in-out infinite;
        }

        .qr-shine {
          position: relative;
          overflow: hidden;
        }

        .qr-shine::before {
          content: "";
          position: absolute;
          top: -35%;
          left: -40%;
          width: 30%;
          height: 170%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,.32), transparent);
          animation: shineMove 4.2s ease-in-out infinite;
          pointer-events: none;
          z-index: 20;
        }

        .qr-template-btn {
          transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease;
        }

        .qr-template-btn:hover {
          transform: translateY(-2px);
        }

        .qr-preview-mini {
          animation: qrFloat 4.5s ease-in-out infinite;
        }

        .qr-page,
        .qr-page * {
          box-sizing: border-box;
        }

        .qr-page {
          width: 100%;
          max-width: 100%;
          min-width: 0;
          overflow-x: hidden;
          color: #0f172a;
        }

        .qr-page input,
        .qr-page textarea,
        .qr-page button,
        .qr-page select {
          max-width: 100%;
          min-width: 0;
        }

        .qr-page button {
          white-space: normal;
        }

        .qr-page button:disabled {
          cursor: not-allowed;
          opacity: 0.58;
          box-shadow: none;
        }

        .qr-page svg,
        .qr-page img {
          max-width: 100%;
        }

        .qr-main-container {
          width: 100%;
          max-width: none;
          margin: 0 auto;
          padding: 20px clamp(14px, 2vw, 32px) 72px;
        }

        .qr-content-shell {
          width: 100%;
          max-width: none;
          min-width: 0;
          margin: 0 auto;
        }

        .qr-language-switch {
          position: relative;
          top: auto;
          right: auto;
          z-index: 1;
          width: 100%;
          padding: 18px clamp(14px, 2vw, 32px) 0;
          display: flex;
          justify-content: flex-end;
          gap: 8px;
        }

        .qr-language-button {
          min-width: 108px;
          min-height: 43px;
          padding: 9px 14px;
          border: 1px solid #cbd5e1;
          border-radius: 11px;
          color: #26364a;
          background: #ffffff;
          box-shadow: 0 5px 15px rgba(15, 23, 42, 0.08);
          font-size: 13px;
          font-weight: 850;
          line-height: 1.2;
          cursor: pointer;
          transition: background 0.18s ease, color 0.18s ease, border-color 0.18s ease;
        }

        .qr-language-button:hover {
          color: #0f4c81;
          border-color: #7fa8ca;
          background: #f1f6fb;
        }

        .qr-language-button.is-active {
          color: #ffffff;
          border-color: #0f4c81;
          background: #0f4c81;
          box-shadow: 0 7px 18px rgba(15, 76, 129, 0.24);
        }

        .qr-primary-card,
        .qr-print-card,
        .qr-primary-grid,
        .qr-print-grid {
          width: 100%;
          max-width: 100%;
          min-width: 0;
        }

        .qr-primary-grid > *,
        .qr-print-grid > * {
          min-width: 0;
        }

        /* Paylaşım bağlantıları */
        .qr-link-guide {
          width: 100%;
          padding: clamp(20px, 2.2vw, 32px);
          border: 1px solid rgba(15, 23, 42, 0.09);
          border-radius: 26px;
          background:
            radial-gradient(circle at 100% 0%, rgba(37, 99, 235, 0.08), transparent 32%),
            linear-gradient(145deg, #ffffff, #f8fafc);
          box-shadow: 0 20px 55px rgba(15, 23, 42, 0.09);
        }

        .qr-guide-heading {
          margin-bottom: 20px;
        }

        .qr-guide-eyebrow {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 8px;
          color: #f97316;
          font-size: 12px;
          font-weight: 950;
          letter-spacing: 0.14em;
        }

        .qr-guide-heading h2 {
          margin: 0;
          color: #0f172a;
          font-size: clamp(25px, 3vw, 38px);
          font-weight: 950;
          line-height: 1.12;
          letter-spacing: -0.035em;
        }

        .qr-guide-heading p {
          max-width: 980px;
          margin: 10px 0 0;
          color: #64748b;
          font-size: 15px;
          font-weight: 650;
          line-height: 1.7;
        }

        .qr-institution-identity {
          width: 100%;
          margin: 0 0 20px;
          padding: 16px 18px;
          display: grid;
          grid-template-columns: minmax(280px, 1fr) auto;
          align-items: center;
          gap: 18px;
          border: 1px solid #cbd5e1;
          border-left: 5px solid #0f4c81;
          border-radius: 16px;
          background: #ffffff;
          box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
        }

        .qr-identity-heading {
          min-width: 0;
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .qr-identity-icon {
          width: 44px;
          height: 44px;
          flex: 0 0 44px;
          display: grid;
          place-items: center;
          border-radius: 12px;
          color: #ffffff;
          background: #0f4c81;
          font-size: 21px;
        }

        .qr-identity-heading strong {
          display: block;
          color: #0f172a;
          font-size: 16px;
          font-weight: 900;
          line-height: 1.3;
        }

        .qr-identity-heading p {
          margin: 4px 0 0;
          color: #334155;
          font-size: 13px;
          font-weight: 650;
          line-height: 1.5;
        }

        .qr-identity-values {
          display: grid;
          grid-template-columns: repeat(2, minmax(130px, 1fr));
          gap: 10px;
        }

        .qr-identity-values > div {
          min-width: 130px;
          padding: 10px 14px;
          border: 1px solid #d8e1ea;
          border-radius: 12px;
          background: #f8fafc;
        }

        .qr-identity-values span {
          display: block;
          color: #475569;
          font-size: 10px;
          font-weight: 850;
          letter-spacing: 0.08em;
          text-transform: uppercase;
        }

        .qr-identity-values b {
          display: block;
          margin-top: 3px;
          color: #0f172a;
          font-size: 18px;
          font-weight: 950;
          overflow-wrap: anywhere;
        }

        .qr-identity-warning {
          grid-column: 1 / -1;
          margin: -4px 0 0;
          padding: 10px 12px;
          display: flex;
          align-items: flex-start;
          gap: 8px;
          border: 1px solid #f3c98b;
          border-radius: 10px;
          color: #78350f;
          background: #fff8eb;
          font-size: 13px;
          font-weight: 750;
          line-height: 1.5;
        }

        .qr-identity-warning span {
          width: 20px;
          height: 20px;
          flex: 0 0 20px;
          display: grid;
          place-items: center;
          border-radius: 50%;
          color: #ffffff;
          background: #b45309;
          font-size: 12px;
          font-weight: 950;
        }

        .qr-guide-list {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .qr-guide-item {
          width: 100%;
          overflow: hidden;
          border: 1px solid var(--guide-border);
          border-left: 5px solid var(--guide-color);
          border-radius: 16px;
          background: #ffffff;
          box-shadow: 0 7px 20px rgba(15, 23, 42, 0.055);
        }

        .qr-guide-item.is-open {
          box-shadow: 0 15px 34px rgba(15, 23, 42, 0.11);
        }

        .qr-guide-toggle {
          width: 100%;
          padding: 15px 17px;
          display: grid;
          grid-template-columns: 48px minmax(0, 1fr) 34px;
          align-items: center;
          gap: 13px;
          border: 0;
          color: #0f172a;
          background: #ffffff;
          text-align: left;
          cursor: pointer;
        }

        .qr-guide-toggle:hover {
          background: var(--guide-soft);
        }

        .qr-guide-icon {
          width: 48px;
          height: 48px;
          display: grid;
          place-items: center;
          border-radius: 15px;
          color: #ffffff;
          background: var(--guide-color);
          box-shadow: 0 7px 16px rgba(15, 23, 42, 0.16);
          font-size: 23px;
        }

        .qr-guide-title {
          min-width: 0;
        }

        .qr-guide-title strong {
          display: block;
          color: var(--guide-deep);
          font-size: 16px;
          font-weight: 950;
          line-height: 1.25;
          overflow-wrap: anywhere;
        }

        .qr-guide-title span {
          display: inline-flex;
          margin-top: 5px;
          padding: 4px 8px;
          border-radius: 999px;
          color: var(--guide-deep);
          background: var(--guide-soft);
          font-size: 11px;
          font-weight: 900;
          letter-spacing: 0.04em;
        }

        .qr-guide-chevron {
          width: 34px;
          height: 34px;
          display: grid;
          place-items: center;
          border-radius: 11px;
          color: var(--guide-deep);
          background: #ffffff;
          box-shadow: 0 5px 16px rgba(15, 23, 42, 0.09);
          font-size: 20px;
          transition: transform 0.2s ease;
        }

        .qr-guide-item.is-open .qr-guide-chevron {
          transform: rotate(180deg);
        }

        .qr-guide-body {
          padding: 20px;
          border-top: 1px solid var(--guide-border);
          background: #ffffff;
          animation: qrGuideOpen 0.22s ease;
        }

        @keyframes qrGuideOpen {
          from { opacity: 0; transform: translateY(-6px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .qr-guide-content {
          display: grid;
          grid-template-columns: minmax(0, 1fr) 180px;
          align-items: center;
          gap: 22px;
        }

        .qr-guide-description {
          margin: 0;
          color: #27364a;
          font-size: 15px;
          font-weight: 600;
          line-height: 1.7;
        }

        .qr-guide-url {
          margin-top: 13px;
          padding: 11px 13px;
          border: 1px solid var(--guide-border);
          border-radius: 12px;
          color: var(--guide-deep);
          background: var(--guide-soft);
          font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
          font-size: 12px;
          font-weight: 800;
          overflow-wrap: anywhere;
        }

        .qr-guide-url.is-unavailable {
          color: #7c2d12;
          border-color: #f0c38d;
          background: #fff8eb;
          font-family: inherit;
          font-size: 13px;
          line-height: 1.55;
        }

        .qr-guide-steps {
          margin: 15px 0 0;
          padding: 0;
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 9px;
          list-style: none;
        }

        .qr-guide-steps li {
          min-width: 0;
          padding: 10px;
          display: flex;
          align-items: flex-start;
          gap: 8px;
          border: 1px solid #e8edf3;
          border-radius: 12px;
          color: #334155;
          background: #fbfdff;
          font-size: 12px;
          font-weight: 700;
          line-height: 1.5;
        }

        .qr-guide-steps b {
          width: 22px;
          height: 22px;
          flex: 0 0 22px;
          display: grid;
          place-items: center;
          border-radius: 7px;
          color: #ffffff;
          background: var(--guide-color);
          font-size: 10px;
        }

        .qr-guide-code {
          padding: 12px;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 8px;
          border: 1px solid var(--guide-border);
          border-radius: 17px;
          background: var(--guide-soft);
        }

        .qr-guide-code-inner {
          width: 142px;
          height: 142px;
          padding: 7px;
          display: grid;
          place-items: center;
          border-radius: 13px;
          background: #ffffff;
          box-shadow: 0 8px 24px rgba(15, 23, 42, 0.11);
        }

        .qr-guide-code-empty {
          width: 100%;
          height: 100%;
          display: grid;
          place-items: center;
          color: #64748b;
          border: 1px dashed #cbd5e1;
          border-radius: 9px;
          background: #f8fafc;
          font-size: 34px;
        }

        .qr-guide-code small {
          color: var(--guide-deep);
          font-size: 10px;
          font-weight: 900;
          text-align: center;
        }

        .qr-guide-actions {
          margin-top: 16px;
          display: flex;
          flex-wrap: wrap;
          gap: 9px;
        }

        .qr-guide-action {
          min-height: 42px;
          padding: 10px 14px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 7px;
          border-radius: 12px;
          font-size: 12px;
          font-weight: 900;
          cursor: pointer;
          transition: transform 0.18s ease, box-shadow 0.18s ease;
        }

        .qr-guide-action:hover {
          transform: translateY(-1px);
        }

        .qr-guide-action.share {
          border: 1px solid var(--guide-color);
          color: #ffffff;
          background: var(--guide-color);
          box-shadow: 0 8px 18px rgba(15, 23, 42, 0.14);
        }

        .qr-guide-action.copy {
          border: 1px solid var(--guide-border);
          color: var(--guide-deep);
          background: #ffffff;
        }

        .qr-guide-action.prepare {
          border: 1px solid transparent;
          color: var(--guide-deep);
          background: var(--guide-soft);
        }

        .qr-guide-action:disabled {
          color: #64748b;
          border-color: #cbd5e1;
          background: #e9eef4;
          box-shadow: none;
          cursor: not-allowed;
          opacity: 1;
          transform: none;
        }

        @media (max-width: 768px) {
          .qr-main-container {
            padding: 14px 8px 56px;
          }

          .qr-language-switch {
            width: 100%;
            padding: 12px 8px 0;
            display: grid;
            grid-template-columns: repeat(3, minmax(0, 1fr));
            gap: 6px;
          }

          .qr-language-button {
            min-width: 0;
            min-height: 42px;
            padding: 8px 5px;
            font-size: 12px;
          }

          .qr-page-heading {
            margin-bottom: 22px !important;
            padding: 0 6px;
          }

          .qr-page-heading h1 {
            font-size: clamp(27px, 8vw, 36px);
            line-height: 1.08;
          }

          .qr-page-heading p {
            font-size: 14px;
          }

          .qr-content-shell {
            width: 100%;
          }

          .qr-primary-grid,
          .qr-print-grid {
            grid-template-columns: minmax(0, 1fr) !important;
            gap: 16px !important;
            padding: 14px !important;
          }

          .qr-link-guide {
            padding: 16px;
            border-radius: 20px;
          }

          .qr-guide-heading {
            margin-bottom: 15px;
          }

          .qr-guide-heading h2 {
            font-size: 24px;
          }

          .qr-guide-heading p {
            font-size: 13px;
            line-height: 1.6;
          }

          .qr-institution-identity {
            padding: 14px;
            grid-template-columns: minmax(0, 1fr);
            gap: 13px;
            border-left-width: 4px;
          }

          .qr-identity-heading {
            align-items: flex-start;
          }

          .qr-identity-heading p {
            font-size: 12px;
          }

          .qr-identity-values {
            grid-template-columns: repeat(2, minmax(0, 1fr));
          }

          .qr-identity-values > div {
            min-width: 0;
            padding: 10px;
          }

          .qr-identity-values b {
            font-size: 16px;
          }

          .qr-guide-toggle {
            padding: 12px;
            grid-template-columns: 42px minmax(0, 1fr) 30px;
            gap: 10px;
          }

          .qr-guide-icon {
            width: 42px;
            height: 42px;
            border-radius: 13px;
            font-size: 20px;
          }

          .qr-guide-title strong {
            font-size: 15px;
          }

          .qr-guide-chevron {
            width: 30px;
            height: 30px;
          }

          .qr-guide-body {
            padding: 14px;
          }

          .qr-guide-description {
            font-size: 14px;
          }

          .qr-guide-content {
            grid-template-columns: minmax(0, 1fr);
            gap: 15px;
          }

          .qr-guide-code {
            width: 100%;
          }

          .qr-guide-steps {
            grid-template-columns: minmax(0, 1fr);
          }

          .qr-guide-actions {
            display: grid;
            grid-template-columns: minmax(0, 1fr);
          }

          .qr-guide-action {
            width: 100%;
            min-height: 44px;
          }

          .qr-professional-preview {
            position: static !important;
            top: auto !important;
          }

          .qr-preview-mini {
            animation: none;
          }

          .qr-page input,
          .qr-page button,
          .qr-page textarea {
            font-size: 16px;
          }
        }

        @media (max-width: 390px) {
          .qr-link-guide {
            padding: 12px;
          }

          .qr-guide-toggle {
            grid-template-columns: 38px minmax(0, 1fr) 28px;
            padding: 10px;
          }

          .qr-guide-icon {
            width: 38px;
            height: 38px;
          }
        }
      `}</style>

      {/* Export için gizli QR kaynak */}
      <div
        style={{
          position: "absolute",
          left: "-99999px",
          top: "-99999px",
          width: 0,
          height: 0,
          overflow: "hidden",
          opacity: 0,
          pointerEvents: "none",
        }}
      >
        <QRCodeSVG
          id="qr-code-print-source"
          value={qrValue || " "}
          size={900}
          level="H"
          includeMargin={true}
          bgColor="#ffffff"
          fgColor="#000000"
        />
      </div>

      {/* Dil seçici */}
      <div className="qr-language-switch" aria-label="Sayfa dili">
        {[
          { code: "tr", label: "Türkçe" },
          { code: "en", label: "English" },
          { code: "de", label: "Deutsch" },
        ].map((language) => (
          <button
            type="button"
            key={language.code}
            onClick={() => setUiLang(language.code)}
            className={`qr-language-button ${
              uiLang === language.code ? "is-active" : ""
            }`}
            aria-pressed={uiLang === language.code}
          >
            {language.label}
          </button>
        ))}
      </div>

      <div className="qr-main-container">
        {/* Başlık */}
        <div className="qr-page-heading text-center mb-10 max-w-5xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white shadow border border-orange-100 text-orange-700 font-bold mb-4">
            <span>⚡</span>
            <span>MesYat Dijital QR Sistemi</span>
          </div>

          <h1 className="text-3xl md:text-5xl font-black text-gray-950 mb-4 tracking-tight">
            {TT.title}
          </h1>

          <p className="text-lg md:text-xl text-gray-600 leading-relaxed">
            {TT.subtitle}
          </p>
        </div>

        <div className="qr-content-shell max-w-7xl mx-auto space-y-8">
          {/* Renkli, kolay anlaşılır paylaşım bağlantıları */}
          <section className="qr-link-guide" aria-labelledby="qr-guide-title">
            <div className="qr-guide-heading">
              <span className="qr-guide-eyebrow">
                <span>✦</span>
                {GUIDE.eyebrow}
              </span>

              <h2 id="qr-guide-title">{GUIDE.title}</h2>
              <p>{GUIDE.subtitle}</p>
            </div>

            <div className="qr-institution-identity">
              <div className="qr-identity-heading">
                <span className="qr-identity-icon" aria-hidden="true">🏢</span>
                <div>
                  <strong>{TT.institutionIdentity}</strong>
                  <p>{TT.institutionIdentityNote}</p>
                </div>
              </div>

              <div className="qr-identity-values">
                <div>
                  <span>{TT.institutionCode}</span>
                  <b>{institutionCode || "—"}</b>
                </div>
                <div>
                  <span>{TT.institutionId}</span>
                  <b>{institutionId || "—"}</b>
                </div>
              </div>

              {institutionError && (
                <p className="qr-identity-warning" role="status">
                  <span aria-hidden="true">!</span>
                  {institutionError}
                </p>
              )}
            </div>

            <div className="qr-guide-list">
              {guideItems.map((item) => (
                <ShareLinkAccordion
                  key={item.key}
                  item={item}
                  open={openGuideKey === item.key}
                  onToggle={() =>
                    setOpenGuideKey((current) =>
                      current === item.key ? "" : item.key
                    )
                  }
                  onShare={() => shareGuideLink(item)}
                  onCopy={() => copyGuideLink(item)}
                  onPrepare={() => prepareGuideQr(item)}
                  copied={guideCopied === item.key}
                  ready={guideReady === item.key}
                  labels={GUIDE}
                />
              ))}
            </div>
          </section>

          {/* Üst QR ve link alanı */}
          <div className="qr-primary-card bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100">
            <div className="qr-primary-grid grid lg:grid-cols-2 gap-8 p-6 md:p-8">
              <div className="flex flex-col items-center justify-center p-6 bg-gradient-to-br from-orange-100 via-white to-blue-100 rounded-3xl">
                <div className="bg-white p-5 rounded-3xl shadow-xl qr-preview-mini">
                  {qrValue?.trim() ? (
                    <QRCodeSVG
                      id="qr-code-canvas"
                      value={qrValue}
                      size={250}
                      level="H"
                      includeMargin={true}
                      ref={qrRef}
                    />
                  ) : (
                    <div className="w-64 h-64 max-w-full grid place-items-center rounded-2xl border-2 border-dashed border-slate-300 bg-slate-50 px-6 text-center text-sm font-bold text-slate-600">
                      {TT.institutionDataMissing}
                    </div>
                  )}
                </div>

                <h3 className="text-xl font-black text-gray-900 mt-6 mb-2">
                  {TT.qrPreview}
                </h3>

                <p className="text-sm text-gray-600 text-center break-all max-w-full px-2 mb-6">
                  {qrValue || "QR adresini yazınız"}
                </p>

                <div className="grid sm:grid-cols-2 gap-3 w-full">
                  <button
                    onClick={downloadQR}
                    disabled={!qrValue?.trim()}
                    className="bg-orange-600 hover:bg-orange-700 text-white font-extrabold py-3 px-4 rounded-2xl transition shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
                  >
                    <span>⬇️</span>
                    {TT.downloadQr}
                  </button>

                  <button
                    onClick={shareQR}
                    disabled={!qrValue?.trim()}
                    className="bg-gray-900 hover:bg-black text-white font-extrabold py-3 px-4 rounded-2xl transition shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
                  >
                    <span>📤</span>
                    {TT.share}
                  </button>
                </div>
              </div>

              <div className="flex flex-col justify-center space-y-6">
                <div>
                  <h3 className="text-lg font-black text-gray-800 mb-2">
                    {TT.qrLink}
                  </h3>

                  <div className="flex flex-col sm:flex-row gap-2">
                    <input
                      type="text"
                      value={qrValue}
                      readOnly
                      className="flex-1 p-3 bg-gray-50 border border-gray-200 rounded-2xl text-sm text-gray-700 focus:ring-2 focus:ring-orange-300 outline-none transition break-all"
                    />

                    <button
                      onClick={copyToClipboard}
                      disabled={!qrValue?.trim()}
                      className="px-5 py-3 bg-gray-100 hover:bg-gray-200 rounded-2xl transition font-extrabold shadow-sm"
                    >
                      {copied ? (
                        <span className="text-green-600">{TT.copied}</span>
                      ) : (
                        TT.copy
                      )}
                    </button>
                  </div>
                </div>

                <div className="border-t border-gray-100 pt-5">
                  <label className="block text-sm font-black text-gray-800 mb-2">
                    {TT.customUrlLabel}
                  </label>

                  <div className="flex flex-col sm:flex-row gap-2">
                    <input
                      type="text"
                      value={customUrl}
                      onChange={handleCustomUrlChange}
                      placeholder={TT.customUrlPlaceholder}
                      className="flex-1 p-3 border border-gray-300 rounded-2xl text-sm focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none transition"
                    />

                    <button
                      onClick={resetToInstitutionLink}
                      className="px-5 py-3 bg-orange-100 hover:bg-orange-200 text-orange-800 rounded-2xl text-sm font-black transition"
                    >
                      {TT.reset}
                    </button>
                  </div>

                  <p className="text-xs text-gray-500 mt-2">
                    {TT.defaultLinkInfo}:{" "}
                    <b>{defaultMenuLink || TT.institutionDataMissing}</b>
                  </p>
                  <p className="text-xs text-slate-700 mt-2 font-semibold">
                    {TT.institutionIdentityNote}
                  </p>
                </div>

                <div className="border-t border-gray-100 pt-5">
                  <h3 className="text-lg font-black text-gray-800 mb-4">
                    {TT.howToUse}
                  </h3>

                  <ul className="space-y-3">
                    {TT.notes.map((note, index) => (
                      <li key={index} className="flex gap-3 items-start">
                        <span className="w-7 h-7 bg-orange-100 text-orange-700 rounded-full flex items-center justify-center font-black text-sm flex-shrink-0">
                          {index + 1}
                        </span>
                        <span className="text-gray-600 leading-relaxed">
                          {note}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Profesyonel baskı alanı */}
          <div className="qr-print-card bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100">
            <div className="p-6 md:p-8 border-b border-gray-100 bg-gradient-to-r from-gray-950 to-gray-800">
              <div className="flex flex-col xl:flex-row xl:items-end xl:justify-between gap-5">
                <div>
                  <h2 className="text-2xl md:text-4xl font-black text-white tracking-tight">
                    {TT.printTitle}
                  </h2>

                  <p className="text-gray-300 mt-2 max-w-3xl leading-relaxed">
                    {TT.printSubtitle}
                  </p>
                </div>

                <div className="flex flex-col sm:flex-row gap-3">
                  <button
                    onClick={downloadProfessionalPrintPNG}
                    disabled={!qrValue?.trim()}
                    className="bg-orange-600 hover:bg-orange-700 text-white px-5 py-3 rounded-2xl font-black shadow-lg hover:shadow-xl transition flex items-center justify-center gap-2"
                  >
                    <span>🖼️</span>
                    {TT.downloadPng}
                  </button>

                  <button
                    onClick={downloadProfessionalPrintSVG}
                    disabled={!qrValue?.trim()}
                    className="bg-white hover:bg-gray-100 text-gray-950 px-5 py-3 rounded-2xl font-black shadow-lg hover:shadow-xl transition flex items-center justify-center gap-2"
                  >
                    <span>📄</span>
                    {TT.downloadSvg}
                  </button>
                </div>
              </div>
            </div>

            <div className="qr-print-grid grid xl:grid-cols-2 gap-8 p-6 md:p-8">
              {/* Ayarlar */}
              <div className="space-y-6">
                <PanelBox title={TT.templateType} icon="🧩">
                  <div className="grid sm:grid-cols-2 gap-3">
                    {templateButtons.map((item) => (
                      <button
                        key={item.key}
                        type="button"
                        onClick={() => applyTemplate(item.key)}
                        className={`qr-template-btn p-4 rounded-2xl border text-left ${
                          templateType === item.key
                            ? "border-orange-500 bg-orange-50 shadow-lg ring-4 ring-orange-100"
                            : "border-gray-200 bg-white hover:bg-gray-50 shadow-sm"
                        }`}
                      >
                        <div className="flex items-center gap-3">
                          <span className="text-2xl">{item.icon}</span>
                          <div>
                            <div className="font-black text-gray-950">
                              {item.label}
                            </div>
                            <div className="text-xs text-gray-500 mt-1">
                              {item.key === "muhtar" &&
                                "Muhtarlık duyuru ve takip QR"}
                              {item.key === "dernek" &&
                                "Dernek destek ve uygulama QR"}
                              {item.key === "app" &&
                                "Google Play / App Store QR"}
                              {item.key === "menu" &&
                                "Restoran, cafe ve masa QR"}
                              {item.key === "simple" &&
                                "Yazısız özel bağlantı QR"}
                            </div>
                          </div>
                        </div>
                      </button>
                    ))}
                  </div>
                </PanelBox>

                <PanelBox title={TT.textSettings} icon="✍️">
                  <div className="grid md:grid-cols-2 gap-4">
                    <TextInput
                      label={TT.businessName}
                      value={printBusinessName}
                      onChange={setPrintBusinessName}
                      placeholder="MESYAT / MUHTARLIĞIMIZ / DERNEĞİMİZ"
                    />

                    <TextInput
                      label={TT.sideText}
                      value={sideText}
                      onChange={setSideText}
                      placeholder="MUHTARLIK"
                    />

                    <TextInput
                      label={TT.titleLine1}
                      value={titleLine1}
                      onChange={setTitleLine1}
                      placeholder="MUHTARLIĞIMIZI"
                    />

                    <TextInput
                      label={TT.titleLine2}
                      value={titleLine2}
                      onChange={setTitleLine2}
                      placeholder="TAKİP EDELİM"
                    />
                  </div>

                  <div className="mt-4">
                    <label className="block text-sm font-black text-gray-800 mb-2">
                      {TT.footerText}
                    </label>

                    <textarea
                      value={footerText}
                      onChange={(e) => setFooterText(e.target.value)}
                      placeholder="Duyuru, etkinlik ve bilgilendirmeler için QR kodu okutunuz"
                      rows={3}
                      className="w-full p-3 border border-gray-300 rounded-2xl text-sm focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none transition resize-none"
                    />
                  </div>
                </PanelBox>

                <PanelBox title={TT.colorSettings} icon="🎨">
                  <div className="grid md:grid-cols-2 gap-4">
                    <ColorInput
                      label={TT.bgColor}
                      value={backgroundColor}
                      onChange={setBackgroundColor}
                    />

                    <ColorInput
                      label={TT.accentColor}
                      value={accentColor}
                      onChange={setAccentColor}
                    />

                    <ColorInput
                      label={TT.qrBgColor}
                      value={qrAreaColor}
                      onChange={setQrAreaColor}
                    />

                    <ColorInput
                      label={TT.textColor}
                      value={textColor}
                      onChange={setTextColor}
                    />
                  </div>
                </PanelBox>

                <PanelBox title={TT.logoSettings} icon="🖼️">
                  <div className="flex flex-col sm:flex-row gap-3">
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleLogoUpload}
                      className="flex-1 p-3 border border-gray-300 rounded-2xl text-sm bg-white"
                    />

                    {centerLogoDataUrl && (
                      <button
                        type="button"
                        onClick={() => setCenterLogoDataUrl("")}
                        className="px-5 py-3 bg-gray-200 hover:bg-gray-300 rounded-2xl text-sm font-black transition"
                      >
                        {TT.removeLogo}
                      </button>
                    )}
                  </div>

                  <p className="text-xs text-gray-500 mt-3 leading-relaxed">
                    {TT.printNote}
                  </p>
                </PanelBox>

                <PanelBox title={TT.settings} icon="⚙️">
                  <div className="grid md:grid-cols-2 gap-3">
                    <CheckOption
                      label={TT.showTitle}
                      checked={showTitle}
                      onChange={setShowTitle}
                    />

                    <CheckOption
                      label={TT.showSideText}
                      checked={showSideText}
                      onChange={setShowSideText}
                    />

                    <CheckOption
                      label={TT.showBusiness}
                      checked={showBusiness}
                      onChange={setShowBusiness}
                    />

                    <CheckOption
                      label={TT.showFooter}
                      checked={showFooter}
                      onChange={setShowFooter}
                    />

                    <CheckOption
                      label={TT.showDecor}
                      checked={showDecor}
                      onChange={setShowDecor}
                    />
                  </div>
                </PanelBox>
              </div>

              {/* Canlı önizleme */}
              <div className="flex items-start justify-center">
                <ProfessionalPreview
                  qrValue={qrValue}
                  templateType={templateType}
                  titleLine1={titleLine1}
                  titleLine2={titleLine2}
                  sideText={sideText}
                  footerText={footerText}
                  printBusinessName={printBusinessName}
                  backgroundColor={backgroundColor}
                  accentColor={accentColor}
                  qrAreaColor={qrAreaColor}
                  textColor={textColor}
                  showTitle={showTitle}
                  showSideText={showSideText}
                  showBusiness={showBusiness}
                  showFooter={showFooter}
                  showDecor={showDecor}
                  centerLogoDataUrl={centerLogoDataUrl}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

/* =========================
   YARDIMCI COMPONENTLER
========================= */
function ShareLinkAccordion({
  item,
  open,
  onToggle,
  onShare,
  onCopy,
  onPrepare,
  copied,
  ready,
  labels,
}) {
  const panelId = `qr-guide-panel-${item.key}`;

  return (
    <article
      className={`qr-guide-item ${open ? "is-open" : ""}`}
      style={{
        "--guide-color": item.color,
        "--guide-soft": item.soft,
        "--guide-deep": item.deep,
        "--guide-border": item.border,
      }}
    >
      <button
        type="button"
        className="qr-guide-toggle"
        onClick={onToggle}
        aria-expanded={open}
        aria-controls={panelId}
      >
        <span className="qr-guide-icon" aria-hidden="true">
          {item.icon}
        </span>

        <span className="qr-guide-title">
          <strong>{item.title}</strong>
          <span>{item.tag}</span>
        </span>

        <span className="qr-guide-chevron" aria-hidden="true">
          ⌄
        </span>
      </button>

      {open && (
        <div id={panelId} className="qr-guide-body">
          <div className="qr-guide-content">
            <div>
              <p className="qr-guide-description">{item.description}</p>
              <div
                className={`qr-guide-url ${
                  item.url ? "" : "is-unavailable"
                }`}
              >
                {item.url || item.unavailableText}
              </div>

              <ol className="qr-guide-steps">
                {item.steps.map((step, index) => (
                  <li key={`${item.key}-step-${index}`}>
                    <b>{index + 1}</b>
                    <span>{step}</span>
                  </li>
                ))}
              </ol>
            </div>

            <div className="qr-guide-code">
              <div className="qr-guide-code-inner">
                {item.url ? (
                  <QRCodeSVG
                    value={item.url}
                    size={128}
                    level="H"
                    includeMargin={true}
                  />
                ) : (
                  <div className="qr-guide-code-empty" aria-hidden="true">
                    ▦
                  </div>
                )}
              </div>
              <small>{item.url ? item.tag : labels.unavailable}</small>
            </div>
          </div>

          <div className="qr-guide-actions">
            <button
              type="button"
              className="qr-guide-action share"
              onClick={onShare}
              disabled={!item.url}
            >
              <span>📤</span>
              {labels.shareFriend}
            </button>

            <button
              type="button"
              className="qr-guide-action copy"
              onClick={onCopy}
              disabled={!item.url}
            >
              <span>{copied ? "✓" : "🔗"}</span>
              {copied ? labels.copied : labels.copyLink}
            </button>

            <button
              type="button"
              className="qr-guide-action prepare"
              onClick={onPrepare}
              disabled={!item.url}
            >
              <span>{ready ? "✓" : "▦"}</span>
              {ready ? labels.ready : labels.prepareQr}
            </button>
          </div>
        </div>
      )}
    </article>
  );
}

function PanelBox({ title, icon, children }) {
  return (
    <div className="bg-gray-50 border border-gray-200 rounded-3xl p-5 shadow-sm">
      <h3 className="text-lg font-black text-gray-950 mb-4 flex items-center gap-2">
        <span>{icon}</span>
        {title}
      </h3>
      {children}
    </div>
  );
}

function TextInput({ label, value, onChange, placeholder }) {
  return (
    <label className="block">
      <span className="block text-sm font-black text-gray-800 mb-2">
        {label}
      </span>

      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full p-3 border border-gray-300 rounded-2xl text-sm focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none transition"
      />
    </label>
  );
}

function ColorInput({ label, value, onChange }) {
  return (
    <label className="block">
      <span className="block text-sm font-black text-gray-800 mb-2">
        {label}
      </span>

      <div className="flex items-center gap-2 border border-gray-300 rounded-2xl p-2 bg-white">
        <input
          type="color"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-12 h-10 border-0 bg-transparent cursor-pointer"
        />

        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="flex-1 text-sm outline-none uppercase"
        />
      </div>
    </label>
  );
}

function CheckOption({ label, checked, onChange }) {
  return (
    <label className="flex items-center justify-between gap-4 bg-white border border-gray-200 rounded-2xl p-4 cursor-pointer shadow-sm">
      <span className="font-black text-gray-800 text-sm">{label}</span>

      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="w-5 h-5 accent-orange-600"
      />
    </label>
  );
}

/* =========================
   CANLI ÖNİZLEME
========================= */
function ProfessionalPreview({
  qrValue,
  templateType,
  titleLine1,
  titleLine2,
  sideText,
  footerText,
  printBusinessName,
  backgroundColor,
  accentColor,
  qrAreaColor,
  textColor,
  showTitle,
  showSideText,
  showBusiness,
  showFooter,
  showDecor,
  centerLogoDataUrl,
}) {
  const isSimple = templateType === "simple";

  const verticalLetters = String(sideText || "")
    .replace(/\s+/g, "")
    .toUpperCase()
    .slice(0, 10)
    .split("")
    .filter(Boolean);

  const footerPreview = String(footerText || "");

  return (
    <div className="qr-professional-preview w-full max-w-[520px] sticky top-8">
      <div className="text-center mb-4">
        <div className="inline-flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow border border-gray-100 text-gray-800 font-black">
          <span>👁️</span>
          Canlı Önizleme
        </div>
      </div>

      <div
        className="qr-animated-card bg-white shadow-2xl"
        style={{
          width: "100%",
          aspectRatio: "1 / 1",
          borderRadius: 34,
          padding: 16,
        }}
      >
        <div
          className="qr-shine relative w-full h-full overflow-hidden"
          style={{
            background: backgroundColor,
            borderRadius: "18%",
            border: `3px solid ${hexWithAlpha(accentColor, "70")}`,
          }}
        >
          {showDecor && (
            <>
              <div
                style={{
                  position: "absolute",
                  width: "34%",
                  height: "34%",
                  borderRadius: "50%",
                  background: accentColor,
                  opacity: 0.08,
                  left: "7%",
                  top: "8%",
                }}
              />

              <div
                style={{
                  position: "absolute",
                  width: "38%",
                  height: "38%",
                  borderRadius: "50%",
                  background: accentColor,
                  opacity: 0.09,
                  right: "-5%",
                  bottom: "-6%",
                }}
              />

              <div
                style={{
                  position: "absolute",
                  width: "12%",
                  height: "12%",
                  borderRadius: "50%",
                  background: accentColor,
                  opacity: 0.16,
                  right: "12%",
                  top: "12%",
                }}
              />
            </>
          )}

          {!isSimple && showTitle && (
            <div
              className="absolute left-4 right-4 text-center z-10"
              style={{
                top: "6%",
                color: textColor,
                fontWeight: 950,
                lineHeight: 1.02,
                letterSpacing: 0.8,
                textTransform: "uppercase",
              }}
            >
              <div
                style={{
                  fontSize:
                    titleLine1.length > 18
                      ? "clamp(18px, 4vw, 28px)"
                      : "clamp(22px, 5vw, 36px)",
                }}
              >
                {titleLine1}
              </div>

              <div
                style={{
                  fontSize:
                    titleLine2.length > 18
                      ? "clamp(17px, 3.7vw, 25px)"
                      : "clamp(20px, 4.5vw, 32px)",
                  marginTop: 6,
                }}
              >
                {titleLine2}
              </div>
            </div>
          )}

          {!isSimple && showSideText && verticalLetters.length > 0 && (
            <>
              <SideLetters
                letters={verticalLetters}
                side="left"
                textColor={textColor}
              />

              <SideLetters
                letters={verticalLetters}
                side="right"
                textColor={textColor}
              />
            </>
          )}

          <div
            className="absolute flex items-center justify-center z-10"
            style={{
              left: isSimple ? "18%" : "27%",
              right: isSimple ? "18%" : "27%",
              top: isSimple ? "18%" : "26%",
              aspectRatio: "1 / 1",
              padding: isSimple ? "4%" : "1.8%",
              borderRadius: isSimple ? 28 : 14,
              background: qrAreaColor,
              boxShadow: "0 20px 50px rgba(0,0,0,.24)",
            }}
          >
            <QRCodeSVG
              value={qrValue || " "}
              size={1000}
              level="H"
              includeMargin={true}
              bgColor="#ffffff"
              fgColor="#000000"
              style={{
                width: "100%",
                height: "100%",
                display: "block",
              }}
            />

            {centerLogoDataUrl && (
              <img
                src={centerLogoDataUrl}
                alt="logo"
                style={{
                  position: "absolute",
                  width: "20%",
                  height: "20%",
                  objectFit: "cover",
                  borderRadius: "50%",
                  background: qrAreaColor,
                  padding: 5,
                  boxShadow: "0 8px 20px rgba(0,0,0,.16)",
                }}
              />
            )}
          </div>

          {!isSimple && showBusiness && printBusinessName && (
            <div
              className="absolute left-5 right-5 text-center z-10"
              style={{
                bottom: showFooter ? "12%" : "8%",
                color: textColor,
                fontWeight: 950,
                fontSize:
                  printBusinessName.length > 20
                    ? "clamp(17px, 4vw, 26px)"
                    : printBusinessName.length > 13
                    ? "clamp(21px, 5vw, 34px)"
                    : "clamp(26px, 6vw, 44px)",
                lineHeight: 1,
                letterSpacing: 1.4,
                textTransform: "uppercase",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {printBusinessName}
            </div>
          )}

          {!isSimple && showFooter && footerPreview && (
            <div
              className="absolute left-6 right-6 text-center z-10"
              style={{
                bottom: "4.2%",
                color: textColor,
                fontWeight: 850,
                fontSize: "clamp(10px, 2.4vw, 17px)",
                lineHeight: 1.2,
              }}
            >
              {footerPreview}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function SideLetters({ letters, side, textColor }) {
  const fontSize =
    letters.length >= 9
      ? "clamp(16px, 3.3vw, 25px)"
      : letters.length >= 7
      ? "clamp(18px, 3.7vw, 29px)"
      : "clamp(22px, 4.6vw, 38px)";

  return (
    <div
      className="absolute flex flex-col items-center justify-center z-10"
      style={{
        [side]: "8%",
        top: "24%",
        bottom: "24%",
        color: textColor,
        fontWeight: 950,
        fontSize,
        lineHeight: 1.06,
        letterSpacing: 0.3,
      }}
    >
      {letters.map((letter, index) => (
        <span key={`${side}-${letter}-${index}`}>{letter}</span>
      ))}
    </div>
  );
}

/* =========================
   RENK ALPHA YARDIMCI
========================= */
function hexWithAlpha(hex, alpha = "80") {
  const clean = String(hex || "").trim();

  if (/^#[0-9A-Fa-f]{6}$/.test(clean)) {
    return `${clean}${alpha}`;
  }

  return clean;
}
